var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8145 1H18.186C25.6165 1 31.639 8.3865 31.639 17.5C31.639 26.6135 25.6165 34 18.186 34H14.8145",
    fill: "#FDE966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8145 1H18.186C25.6165 1 31.639 8.3865 31.639 17.5C31.639 26.6135 25.6165 34 18.186 34H14.8145",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8143 34C22.2442 34 28.2673 26.6127 28.2673 17.5C28.2673 8.3873 22.2442 1 14.8143 1C7.38444 1 1.36133 8.3873 1.36133 17.5C1.36133 26.6127 7.38444 34 14.8143 34Z",
    fill: "#FDE966",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8276 20.7122C11.8276 22.4777 12.7736 23.9242 13.9286 23.9242H15.6886C16.8436 23.9242 17.7896 22.4777 17.7896 20.7122C17.7896 18.9467 16.8436 17.5002 15.6886 17.5002H13.9286C12.7736 17.5002 11.8276 16.0537 11.8276 14.2882C11.8276 12.5227 12.7736 11.0762 13.9286 11.0762H15.6886C16.8436 11.0762 17.7896 12.5227 17.7896 14.2882",
    fill: "#FDE966"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8276 20.7122C11.8276 22.4777 12.7736 23.9242 13.9286 23.9242H15.6886C16.8436 23.9242 17.7896 22.4777 17.7896 20.7122C17.7896 18.9467 16.8436 17.5002 15.6886 17.5002H13.9286C12.7736 17.5002 11.8276 16.0537 11.8276 14.2882C11.8276 12.5227 12.7736 11.0762 13.9286 11.0762H15.6886C16.8436 11.0762 17.7896 12.5227 17.7896 14.2882",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.814 11.0706V8.10059",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.814 26.8948V23.9248",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.e1c7e05c4f6069239e9cb7b37aa41a01.svg";
export { ForwardRef as ReactComponent };